<template>
  <div class="cmp-catalog-statement-checklist dt-page">
    <div class="dt-page--body">
      <div class="flex-container">
        <div class="row-item">
          <div class="cell-item">
            <h3>Checklist of necessary steps to create Royalty Statements</h3>
          </div>
          <div class="cell-item"><h3>Tutorials</h3></div>
        </div>
        <div class="row-item">
          <div class="cell-item"><h4>General Workflow (OVERVIEW)</h4></div>
          <div class="cell-item">
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[0])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
          </div>
        </div>
        <div class="row-item">
          <div class="cell-item">
            <h4>
              Step 1 : Is your <b>REPERTOIRE</b> up to date for both physical
              and digital <b>PRODUCTS</b> and <b>TRACKS?</b>
            </h4>
          </div>
          <div class="cell-item">
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[1])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[2])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[3])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
          </div>
        </div>
        <div class="row-item">
          <div class="cell-item">
            <h4>
              Step 2 : Did you add all licence income and syncs in
              <b> LICENCES?</b> Are the related <b>INVOICES</b> paid?
            </h4>
          </div>
          <div class="cell-item">
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[4])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
          </div>
        </div>
        <div class="row-item">
          <div class="cell-item">
            <h4>
              Step 3 : Did you <b>IMPORT</b> all digital and physical
              <b>SALES</b> for the royalty period? (plus manual <b>ORDERS</b> if
              that's part of your business)
            </h4>
          </div>
          <div class="cell-item">
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[5])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[6])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[7])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
          </div>
        </div>
        <div class="row-item">
          <div class="cell-item">
            <h4>
              Step 4 : Did you create all necessary
              <b> ROYALTY ACCOUNTS </b> and <b>ROYALTY CONTRACTS? </b>
            </h4>
          </div>
          <div class="cell-item">
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[8])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[9])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
          </div>
        </div>
        <div class="row-item">
          <div class="cell-item">
            <h4>
              Step 5 : Do you need to deduct any <b>ADVANCES</b> or include
              manual <b>BALANCES</b> from previous periods?
            </h4>
          </div>
          <div class="cell-item">
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[10])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
          </div>
        </div>

        <div class="row-item">
          <div class="cell-item">
            <h4>
              Step 6 : If necessary, have you added or imported <b> COSTS?</b>
            </h4>
          </div>
          <div class="cell-item">
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[11])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
          </div>
        </div>
        <div class="row-item">
          <div class="cell-item">
            <h4 style="display: flex">
              Step 7 : If you can confirm all of the above for this royalty
              &nbsp; <b> PERIOD </b>, click here :
              <span
                ><button @click="onConfirmRoyaltyDates" class="dt-button v5 s8">
                  {{ $t("confirm_royalty_dates") }}
                </button></span
              >
            </h4>
          </div>
          <div class="cell-item"></div>
        </div>
        <div class="row-item">
          <div class="cell-item">
            <h4 style="display: flex">
              Step 8 : Now you can process &nbsp;
              <b> ROYALTY STATEMENTS </b> &nbsp; individually or run
              <span
                ><button @click="onClickBatchStatment" class="dt-button v5 s8">
                  {{ $t("batch_statements") }}
                </button></span
              >
            </h4>
          </div>
          <div class="cell-item">
            <div
              class="dt-icon-container"
              style="min-width: 30px; max-width: 30px"
            >
              <img
                @click.stop="(e) => onVideoClick(vimeoLink[12])"
                src="static/icons/video.png"
                class="dt-icon v5 s2 img-icon"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { createTableHeader } from "../../../../plugins/datatable";
import InputField from "@plugins/text-field/input-field";

import ModalContainer from "@dtplugins/modal/modal-container";

import ShopManagement from "./shop-management";
import ConfirmRoyalty from "./confirm-royalty-modal";
import CheckContract from "./check-contracts-modal";
import EmailStatement from "./email-statements-modal";
import BatchStatement from "./batch-statement-modal";

export default {
  components: {
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
    ShopManagement,
    ConfirmRoyalty,
    CheckContract,
    EmailStatement,
    BatchStatement,
    //AdvanceSearch,
  },
  data: function () {
    return {
      vimeoLink: [
        "https://vimeo.com/167776384?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=29220",
        "https://vimeo.com/168103553?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=29220",
        "https://vimeo.com/168072505?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=29220",
        "https://vimeo.com/168656238?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=29220",
        "https://vimeo.com/169183921?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=29220",
        "https://vimeo.com/194265803",
        "https://vimeo.com/186156229?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=29220",
        "https://vimeo.com/193924892",
        "https://vimeo.com/169183907?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=29220",
        "https://vimeo.com/213553427?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=29220",
        "https://vimeo.com/168656226?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=29220",
        "https://vimeo.com/186155918?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=29220",
        "",
      ],
    };
  },
  computed: {
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
      });
    },
    Headers: function () {
      return [
        createTableHeader("royalty_account_id", {
          text: "Checklist of necessary steps to create Royalty Statements",
          f: 2,
        }),
        createTableHeader("tutorials", { f: 1 }),
      ];
    },
  },
  methods: {
    onVideoClick: function (link) {
      window.open(link, "_blank");
    },

    onConfirmRoyaltyDates: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "confirm_royalty",
        },
      });
    },

    onClickBatchStatment: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "batch_statement",
        },
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-statement-checklist {
  .dt-page--body {
    --offset: 190px;
  }
  .flex-container {
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
  .row-item {
    padding: 1em;
    display: flex;
    flex-direction: row;
    h3 {
      color: var(--text-accent);
    }
    .cell-item {
      flex: 3;
      .img-icon {
        width: 20px;
        height: 20px;
        border-radius: 0px;
      }
    }
    .cell-item:nth-child(2) {
      flex: 1;
      justify-content: flex-end;
      display: flex;
    }
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
}
</style>